import React from 'react'
import styled, { css } from 'styled-components'
import { CircularProgress } from '@material-ui/core'

export interface IOverlay {
  isShown: boolean
  spinnerColor: string
}

const OverlayWrapper = styled.div<IOverlay>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isShown }) =>
    !isShown &&
    css`
      display: none;
    `};
  svg {
    ${({ spinnerColor }) => css`
      color: ${spinnerColor};
    `};
  }
` as React.ComponentType<any>

export const Overlay = (props: IOverlay) => (
  <OverlayWrapper
    className={`auto-overlay-${props.isShown ? 'displayed' : 'hidden'}`}
    {...props}
  >
    <CircularProgress />
  </OverlayWrapper>
)
